import React from 'react';
import { StyledTopTooltip } from './ResourceSelect.styles';

interface ResourceTooltipWrapperProps {
  /** Is there a tooltip? */
  hasTooltip?: boolean;
  /** The text of the tooltip */
  tooltipText?: string;
  /** The inner content of the wrapper */
  children?: React.ReactNode;
}

export const ResourceTooltipWrapper = ({
  hasTooltip = false,
  tooltipText = 'No options available',
  children,
}: ResourceTooltipWrapperProps) => {
  return (
    <StyledTopTooltip isEnabled={hasTooltip} tooltipContent={tooltipText}>
      {children}
    </StyledTopTooltip>
  );
};

export default ResourceTooltipWrapper;
